document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".accordion-header");

  function ensureInnerWrapper(content) {
    if (!content.querySelector(".accordion-inner")) {
      const inner = document.createElement("div");
      inner.className = "accordion-inner";

      while (content.firstChild) {
        inner.appendChild(content.firstChild);
      }
      content.appendChild(inner);
    }
  }

  function focusAdjacent(currentHeader, direction) {
    const list = Array.from(headers);
    const index = list.indexOf(currentHeader);
    const target =
      direction === "next"
        ? list[index + 1] || list[0]
        : list[index - 1] || list[list.length - 1];
    target.focus();
  }

  function closeAccordion(header) {
    header.setAttribute("aria-expanded", "false");
    header.classList.remove("accordion-expanded");

    const content = document.getElementById(
      header.getAttribute("aria-controls")
    );
    if (!content) return;

    ensureInnerWrapper(content);
    content.setAttribute("aria-hidden", "true");

    const startHeight = content.scrollHeight;
    content.style.height = startHeight + "px";

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });

    const icon = header.querySelector(".accordion-icon");
    if (icon) icon.textContent = "+";
  }

  function openAccordion(header) {
    header.setAttribute("aria-expanded", "true");
    header.classList.add("accordion-expanded");

    const content = document.getElementById(
      header.getAttribute("aria-controls")
    );
    if (!content) return;

    ensureInnerWrapper(content);
    content.setAttribute("aria-hidden", "false");

    content.style.height = "auto";
    const targetHeight = content.scrollHeight;

    content.style.height = "0px";
    requestAnimationFrame(() => {
      content.style.height = targetHeight + "px";
    });

    content.addEventListener(
      "transitionend",
      () => {
        content.style.height = "auto";
      },
      { once: true }
    );

    const icon = header.querySelector(".accordion-icon");
    if (icon) icon.textContent = "–";
  }

  function toggleAccordion(header) {
    const isExpanded = header.getAttribute("aria-expanded") === "true";

    headers.forEach(h => {
      if (h !== header) closeAccordion(h);
    });

    if (isExpanded) {
      closeAccordion(header);
    } else {
      openAccordion(header);
    }
  }

  headers.forEach(header => {
    header.addEventListener("click", () => toggleAccordion(header));

    header.addEventListener("keydown", event => {
      switch (event.key) {
        case "Enter":
        case " ":
          event.preventDefault();
          toggleAccordion(header);
          break;

        case "ArrowDown":
          event.preventDefault();
          focusAdjacent(header, "next");
          break;

        case "ArrowUp":
          event.preventDefault();
          focusAdjacent(header, "prev");
          break;
      }
    });
  });
});
